import { pgSelect, pgEq } from './postgrest';

interface ComponentResponse {
  resource: Array<{
    percent: number;
    soilname: string;
  }>;
}

interface ErrataResponse {
  resource: Array<{
    note: string;
    field: string;
  }>;
}

export class ComponentService {
  async getComponentsForPolygon(polygonId: string): Promise<ComponentResponse> {
    try {
      return await pgSelect('polygon_components', pgEq('poly_id', polygonId));
    } catch (error) {
      console.error('Error fetching components:', error);
      throw error;
    }
  }

  async getErrataForPolygon(polygonId: string): Promise<ErrataResponse> {
    try {
      return await pgSelect('errata_sksis', pgEq('poly_id', polygonId));
    } catch (error) {
      console.error('Error fetching errata:', error);
      throw error;
    }
  }

  async getInitialIrrigationData(irrigClass: string): Promise<any> {
    try {
      return await pgSelect('irrigation_class_rating', pgEq('irrigclass', irrigClass.slice(0, 2)));
    } catch (error) {
      console.error('Error fetching irrigation data:', error);
      throw error;
    }
  }

  async getEcoSiteForPolygon(polygonId: string): Promise<any> {
    try {
      return await pgSelect('ecosite2016_range', pgEq('poly_id', polygonId));
    } catch (error) {
      console.error('Error fetching eco site:', error);
      throw error;
    }
  }
}

export const componentService = new ComponentService();
